document.addEventListener('DOMContentLoaded', function() {
  // Initialize progress bars for all main banner sections
  const bannerSections = document.querySelectorAll('.td-main-banner');

  bannerSections.forEach(function(section) {
    const swiperElement = section.querySelector('swiper-slider');
    if (!swiperElement) return;

    // Skip if pagination is disabled
    const paginationEnabled = section.dataset.paginationEnabled;
    if (!paginationEnabled || paginationEnabled === '') return;

    const autorotateSpeed = parseInt(section.dataset.autorotateSpeed) || 5000;
    const autorotateEnabled = section.dataset.autorotateEnabled === 'true';

    // Function to initialize progress bars
    function initializeProgressBars() {
      const swiper = swiperElement.slider;

      if (!swiper) {
        setTimeout(initializeProgressBars, 100);
        return;
      }

      // Update pagination to include progress bars
      if (swiper.pagination && swiper.pagination.el) {
        // Re-render pagination with custom bullets
        swiper.params.pagination.renderBullet = function(index, className) {
          return '<span class="' + className + '"><span class="swiper-pagination-bullet-progress"></span></span>';
        };

        // Force pagination re-render
        swiper.pagination.render();
        swiper.pagination.update();

        // Function to start progress animation on active bullet
        function startProgressAnimation() {
          const allProgressBars = section.querySelectorAll('.swiper-pagination-bullet-progress');

          // Reset all progress bars
          allProgressBars.forEach(bar => {
            bar.style.width = '0%';
            bar.style.animation = 'none';
          });

          // Trigger reflow
          void section.offsetHeight;

          // Start animation on active bullet
          const activeProgress = section.querySelector('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress');

          if (activeProgress && swiper.autoplay && (swiper.autoplay.running || autorotateEnabled)) {
            const animationDuration = (autorotateSpeed / 1000) + 's';
            activeProgress.style.animation = 'progressBar ' + animationDuration + ' linear forwards';
          }
        }

        // Start animation on init
        setTimeout(startProgressAnimation, 100);

        // Reset and restart progress bars on slide change
        swiper.on('slideChange', function() {
          startProgressAnimation();
        });

        // Handle autoplay pause/resume
        swiper.on('autoplayStop', function() {
          const activeProgress = section.querySelector('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress');
          if (activeProgress) {
            activeProgress.style.animationPlayState = 'paused';
          }
        });

        swiper.on('autoplayStart', function() {
          const activeProgress = section.querySelector('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress');
          if (activeProgress) {
            const currentWidth = activeProgress.offsetWidth;
            if (currentWidth === 0) {
              activeProgress.style.animation = 'progressBar ' + (autorotateSpeed / 1000) + 's linear forwards';
            } else {
              activeProgress.style.animationPlayState = 'running';
            }
          }
        });

        swiper.on('autoplayResume', function() {
          const activeProgress = section.querySelector('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress');
          if (activeProgress) {
            activeProgress.style.animationPlayState = 'running';
          }
        });
      }
    }

    // Start initialization
    initializeProgressBars();
  });
});
